import { render, staticRenderFns } from "./ActaProvisionalDefinitiva.vue?vue&type=template&id=48726802&scoped=true&"
import script from "./ActaProvisionalDefinitiva.vue?vue&type=script&lang=js&"
export * from "./ActaProvisionalDefinitiva.vue?vue&type=script&lang=js&"
import style0 from "./ActaProvisionalDefinitiva.vue?vue&type=style&index=0&id=48726802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48726802",
  null
  
)

export default component.exports